<template>
  <div class="wrap login-wrap">
    <div class="logo-wrap">
      <img src="@/assets/img/logo_coach.png" class="w-270px" alt="better and better" />
    </div>
    <div class="bnb-btn">
      <button class="active" @click="showApp()">앱 열기</button>
    </div>
  </div>
</template>
<script>
export default {
  name: "landing",
  data: () => ({
    uri: "",
    idx: "",
  }),
  mounted() {
    let query = window.location.search;
    let param = new URLSearchParams(query);
    this.uri = param.get("uri");
    this.idx = param.get("idx");
  },
  methods: {
    showApp() {
      if (this.uri == "") {
        location.href = `https://bnb-coach-link.carrotglobal.com`;
      } else {
        if (this.idx == "") {
          location.href = `https://bnb-coach-link.carrotglobal.com/${this.uri}`;
        } else {
          location.href = `https://bnb-coach-link.carrotglobal.com/${this.uri}/${this.idx}`;
        }
      }
    },
  },
};
</script>
